import { useEffect, useState } from 'react';
import { MetronomeEngine } from '@/lib/audioEngine';

// One persistent engine per page so sounds keep playing across navigation.
const LABELS = { player: 'Metronomo', sequencer: 'Sequencer', click: 'Click' };
const engines = {};

export const getEngine = (id) => {
  if (!engines[id]) engines[id] = new MetronomeEngine(id, LABELS[id]);
  return engines[id];
};

export function useEngineRunning(engine) {
  const [running, setRunning] = useState(() => engine.isRunning());
  useEffect(() => {
    setRunning(engine.isRunning());
    return engine.onRunning(setRunning);
  }, [engine]);
  return running;
}

// Last BPM set in the Player metronome (live engine first, then saved settings).
export function playerBpm() {
  if (engines.player) return Math.round(engines.player.bpm);
  try { return Number(JSON.parse(localStorage.getItem('metronomo:last:v3') || '{}').bpm) || 120; } catch { return 120; }
}

// Player engine with its saved settings even if the Player page was never opened.
export function preparedPlayer() {
  const e = getEngine('player');
  if (e.configuredByPage) return e;
  let s = {};
  try { s = JSON.parse(localStorage.getItem('metronomo:last:v3') || '{}'); } catch { /* defaults */ }
  if (s.bpm) e.setBpm(s.bpm);
  if (Array.isArray(s.pattern)) e.setPattern(s.pattern);
  if (Array.isArray(s.barsEnabled)) e.setBarsEnabled(s.barsEnabled);
  if (s.subdivision) e.setSubdivision(s.subdivision);
  if (s.soundType) e.setSoundType(s.soundType);
  if (typeof s.volume === 'number') e.setVolume(s.volume);
  return e;
}

// Starts an engine with a one-off count-in, keeping its own count-in setting for later.
export function startWithCountIn(engine, bars) {
  const saved = engine.countInBars;
  if (engine.isRunning()) engine.stop();
  engine.setCountInBars(bars);
  engine.start();
  engine.setCountInBars(saved);
}
